import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card";
import React from "react";

export interface IStatisticsProps {
    title: string;
    value: string;
    description: string;
    StatIcon: React.ReactElement
}
export const StatisticCard: React.FC<IStatisticsProps> = ({title, value, description, StatIcon}) => {
    return (
        <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">
            {title}
          </CardTitle>
          {StatIcon}
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{value}</div>
          <p className="text-xs text-muted-foreground">
            {description}
          </p>
        </CardContent>
      </Card>
    )
}